import { useAppDispatch } from './useAppDispatch'

export default useAppDispatch
